import { useMediaQuery } from '@chakra-ui/react'
import { useCallback } from 'react'

const useScrollTo = (reference: React.RefObject<HTMLDivElement | null>): (() => void) => {
  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
  const executeScroll = useCallback(
    () => reference?.current?.scrollIntoView({ behavior: 'smooth' }),
    [isTabletOrMobile]
  )

  return executeScroll
}

export default useScrollTo
